module.exports = __webpack_public_path__ + "img/ru.bac50edf.svg";